const sectionPreloader = () => {
  $(() => {
    const preloader = document.getElementById("preloader");
    if (preloader) {
      preloader.classList.add("hide");
      setTimeout(() => {
        preloader.remove();
      }, 1000);
    }
  });
};

export default sectionPreloader;
